import _ from "lodash";
import { getIn } from "formik";
import PropTypes from "prop-types";
import React from "react";

import { cn } from "@/lib/helpers/cn";

import { FormFieldError } from "../FormFieldError/FormFieldError";
import { Radio, RadioGroup } from "../../Radio";
import "../styles.scss";

import "./styles.scss";

export const FormRadioGroup = ({
  className,
  customError,
  disabled,
  formikProps,
  name,
  options,
  radioButtonClassName,
  radioContainerClassName,
  radioLabelClassName,
  subTitle,
  testId,
  title,
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    if (disabled) {
      return;
    }

    await formikProps.setFieldValue(name, event.target.value);
  };

  return (
    <div className={cn("FormField-container", className)}>
      {(title || subTitle) && (
        <div data-public className="FormField-header_container">
          {title && <h3 className="FormField-title">{title}</h3>}
          {subTitle && <h3 className="FormField-subTitle">{subTitle}</h3>}
        </div>
      )}

      <RadioGroup
        className="FormRadioGroup-radio_group"
        disabled={disabled}
        name={name}
        onChange={handleChange}
        value={value}
      >
        {options.map((option) => {
          return (
            <Radio
              className={radioContainerClassName}
              key={option.value}
              label={option.label}
              labelClassName={cn("FormRadioGroup-label", radioLabelClassName)}
              radioClassName={cn("FormRadioGroup-radio_button", radioButtonClassName)}
              testId={testId}
              value={option.value}
              version="v1"
            />
          );
        })}
      </RadioGroup>

      {!customError && errorMessage && isTouched && <FormFieldError>{errorMessage}</FormFieldError>}

      {/* lets the dev pick what is displayed below the text area */}
      {customError && customError(value, errorMessage, isTouched)}
    </div>
  );
};

FormRadioGroup.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  customError: PropTypes.func,
  formikProps: PropTypes.object,
};
